import * as React from 'react';
export const labanquepostaleSvg = React.forwardRef(
  function labanquepostaleSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#0D5694',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M22.42 11.413a.994.994 0 0 1 1.052.758c.057.531-1.255 1.503-1.255 1.503h-9.043a5.72 5.72 0 0 0-4.397-2.26H22.42ZM7.523 21.587 21.72 17.79v.056l-1.764 2.612c-.26.339-.452 1.13-1.13 1.13H7.522ZM3 20.581c6.025-2.26 7.551-2.86 8.297-3.323 1.459-.893 2.363-1.798 2.261-2.453H29L3 20.58Z',
        fill: '#fff',
      }),
    );
  },
);
labanquepostaleSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var labanquepostale = {
  category: 'brand',
  colorable: false,
  name: 'labanquepostale',
  svg: labanquepostaleSvg,
};
